import { FontFamilyOption } from 'app/pages/design/landingPageBuilder/components';
import { useGetGoogleFontsQuery } from 'lib/api/googleFonts/getGoogleFonts';
import { useEffect, useState } from 'react';

export const useFontFamilyOptions = (
  defaultFontFamilyOptions: FontFamilyOption[],
  useNonValue?: boolean
) => {
  const [allFontFamilyOptions, setAllFontFamilyOptions] = useState<
    FontFamilyOption[]
  >([...defaultFontFamilyOptions]);

  const { data: googleFonts } = useGetGoogleFontsQuery(false);

  useEffect(() => {
    if (!googleFonts?.items) return;

    const googleFontsMapped: FontFamilyOption[] = googleFonts.items.map(
      (font: any) => ({
        value: font.family,
        label: font.family,
        variants: font.variants,
        files: font.files,
      })
    );

    // Filter out any default fonts that already exist in the google list
    const googleFontsFiltered = googleFontsMapped.filter(
      googleFont =>
        !defaultFontFamilyOptions.some(
          defaultFont => defaultFont.value === googleFont.value
        )
    );

    const mergedOptions = [
      ...defaultFontFamilyOptions,
      ...googleFontsFiltered,
    ].sort((a, b) => a.value.localeCompare(b.value));

    setAllFontFamilyOptions(mergedOptions);
  }, [googleFonts, defaultFontFamilyOptions]);

  if (useNonValue) {
    return [
      { label: 'None', value: null },
      ...allFontFamilyOptions,
    ] as FontFamilyOption[];
  }

  return allFontFamilyOptions;
};
